function setArrowOffset(carouselTrack) {
    var trackHeight = carouselTrack.offsetHeight;
    var carousel = carouselTrack.closest('.images-carousel');
    var arrowsNav = carousel.querySelector('.arrows');
    var prevArrow = arrowsNav.querySelector('.prev');
    var nextArrow = arrowsNav.querySelector('.next');

    var arrowHeight = prevArrow.offsetHeight;
    var offset = (trackHeight / 2) - (arrowHeight / 2);

    prevArrow.style.top = offset + 'px';
    nextArrow.style.top = offset + 'px';
}

function getFlexGap(element) {
    const styles = window.getComputedStyle(element);
    var gap = 0;

    if (styles) {
        var rawGap = styles.columnGap || styles.gap;
        if (rawGap === 'normal') {
            gap = 0;
        } else {
            gap = parseFloat(rawGap);
        }
    }
    
    return parseFloat(gap);
}

function enableTransformDrag(element, arrowsNav) {
    var isMobile = window.innerWidth < 768;
    var isAnimating = false;
    var isDragging = false;
    var isAutoPlay = element.dataset.autoplay === '1' ? true : false;
    var speed = element.dataset.speed ? element.dataset.speed : 5;

    var autoPlayIntervalId = null;
    var startX = 0;
    var currentTranslate = 0;
    var lastTranslate = 0;

    var itemWidth = 0;
    var itemGap = 0;
    var step = 0;
    var offsetMultiplier = 1;
    var initialOffset = 0;
    var dragThreshold = 5;

    var nextCloneIndex = 0;
    var prevCloneIndex = element.children.length - 1;

    var prevArrow = arrowsNav.querySelector('.prev');
    var nextArrow = arrowsNav.querySelector('.next');

    var firstItem = element.children[0];
    if (firstItem) {
        itemWidth = firstItem.offsetWidth;
        itemGap = getFlexGap(element);

        step = itemWidth + itemGap;
        offsetMultiplier = isMobile ? 0.65 : 0;
        initialOffset = -step * offsetMultiplier;

        element.style.transform = 'translateX(' + initialOffset + 'px)';
        element.style.touchAction = "none";
        currentTranslate = initialOffset;
    }

    var secondItem = element.children[1];
    if (secondItem) {
        secondItem.classList.add('active');
        setActiveItemInfo(secondItem);
        isInitialLoad = false;
    }

    function snapToNearest(position, step) {
        return Math.round((position - initialOffset) / step) * step + initialOffset;
    }

    function setActiveClassForSecondFromSnap(element, currentTranslate) {
        var items = element.children;
        if (items.length > 1) {
            Array.from(items).forEach(function(item) {
                item.classList.remove('active');
            });

            var snappedIndex = Math.round((currentTranslate - initialOffset) / step);
            snappedIndex = snappedIndex === 1 ? -1 : Math.abs(snappedIndex);

            var secondItemIndex = snappedIndex + 1;
            if (secondItemIndex < items.length) {

                var activeItem = items[secondItemIndex];
                activeItem.classList.add('active');
                
                setActiveItemInfo(activeItem);
            }

        }
    }

    function setActiveItemInfo(activeItem) {
        var carousel = activeItem.closest('.images-carousel');
        var info = carousel.querySelector('.images-carousel-item-info');
        info.classList.remove('active');

        var title = activeItem.getAttribute("data-title") || "";
        var description = activeItem.getAttribute("data-description") || "";
        
        var titleEl = carousel.querySelector('.carousel-title');
        var descEl = carousel.querySelector('.carousel-description');

        if (titleEl) titleEl.textContent = title;
        if (descEl) descEl.textContent = description;
        if (title || description) info.classList.add('active');

        // setTimeout(function() {
        //     if (titleEl) titleEl.textContent = title;
        //     if (descEl) descEl.textContent = description;
        //     if (title || description) info.classList.add('active');
        // }, 300);

    }

    function updateTranslate(translateX, direction, rawTranslateX) {
        if (isAnimating) return;
        isAnimating = true;
        
        currentTranslate = translateX;

        var snappedIndex = Math.round((currentTranslate - initialOffset) / step);
            snappedIndex = snappedIndex === 1 ? -1 : Math.abs(snappedIndex);

        var items = Array.from(element.children).filter(function (item) {
            return !item.classList.contains('dynamic-clone');
        });
        var realItemCount = items.length;

        var isSecondToLast = snappedIndex >= realItemCount - 3;
        var isSecond = snappedIndex <= 0;

        if (direction === "next" && isSecondToLast) {
            var firstRealItem = items[nextCloneIndex];
            var clone = firstRealItem.cloneNode(true);
            clone.classList.add('dynamic-clone');
            element.appendChild(clone);

            nextCloneIndex++;

            // console.log('NEXT CLONE INDEX: ', nextCloneIndex);

            if (nextCloneIndex >= realItemCount) {
                nextCloneIndex = 0;
            }

        }

        if(direction === "prev" && isSecond) {
            var lastRealItem = items[prevCloneIndex];
            var clone = lastRealItem.cloneNode(true);
            clone.classList.add('dynamic-clone');

            currentTranslate = translateX - step;

            var adjustedTranslate = translateX - (step * 2);
            if(rawTranslateX) {
                adjustedTranslate = rawTranslateX - step;
            }

            element.style.transition = "none";
            element.style.transitionDuration = '0s';
            element.style.transform = "translateX(" + (adjustedTranslate) + "px)";

            element.prepend(clone);
            prevCloneIndex--;

            // console.log('PREV CLONE INDEX: ', prevCloneIndex);

            if (prevCloneIndex < 0) {
                prevCloneIndex = realItemCount - 1;
            }
            
            // Force reflow to ensure the DOM registers the new state
            void element.offsetHeight;

            element.style.transition = "transform 0.6s ease-in-out";
            element.style.transform = "translateX(" + currentTranslate + "px)";

        } else {

            element.style.transition = "transform 0.6s ease-in-out";
            element.style.transform = "translateX(" + currentTranslate + "px)";

        }
        
        setActiveClassForSecondFromSnap(element, currentTranslate);

        setTimeout( function() {
            element.style.transition = "";
            isAnimating = false;
        }, 600);

    }

    function handleBrowserResize() {
        var firstItem = element.children[0];
        if (firstItem) {
            itemWidth = firstItem.offsetWidth;
            itemGap = getFlexGap(element);
        }
    
        step = itemWidth + itemGap;
        offsetMultiplier = window.innerWidth < 768 ? 0.65 : 0;
        initialOffset = -step * offsetMultiplier;

        updateTranslate(initialOffset);
        setArrowOffset(element);
    }

    function handlePrevArrowClick() {
        stopAutoPlay();
        var maxRight = -step;
        if (currentTranslate - step > maxRight) return;
        
        updateTranslate(currentTranslate + step, 'prev');
    }

    function handleNextArrowClick() {
        stopAutoPlay();
        var totalItems = window.innerWidth < 768 ? element.children.length : element.children.length - 2;

        var maxLeft = -step * (totalItems - offsetMultiplier);
        if (currentTranslate - step < maxLeft) return;

        updateTranslate(currentTranslate - step, 'next');
    }

    function handleNextAutoPlay() {
        var totalItems = window.innerWidth < 768 ? element.children.length : element.children.length - 2;

        var maxLeft = -step * (totalItems - offsetMultiplier);
        if (currentTranslate - step < maxLeft) return;

        updateTranslate(currentTranslate - step, 'next');
    }

    function handleItemClick(e) {
        isDragging = false;
        hasMoved = false;
        
        var activeItem = getCurrentActiveItem();
        var linkElm = activeItem ? activeItem.querySelector('.custom-link') : null;
        var url = linkElm.getAttribute('href');
        var video = linkElm.dataset.videoModal;
        var modal = linkElm.dataset.promoLink;

        if (video || modal) {
            return linkElm.click();
        }

        if (url) {
            e.stopPropagation();

            if(url.includes('mailto:')) {
                return window.location.href = url;
            }

            var a = document.createElement('a');
            a.href = url;
            a.rel = 'noopener noreferrer';
            a.click();
            a.remove();
        }
    }

    function getCurrentActiveIndex() {
        var offset = -currentTranslate;
        
        var index = Math.round((offset / (itemWidth + itemGap)) + 1);
        
        var items = element.querySelectorAll('.images-carousel-item');
        if (index < 0) index = 0;
        if (index >= items.length) index = items.length - 1;
        
        return index;
    }

    function getCurrentActiveItem() {
        var index = getCurrentActiveIndex();
        var items = element.querySelectorAll('.images-carousel-item');
        return items[index];
    }

    function onPointerDown(e) {
        e.preventDefault();

        if (isAnimating) return;

        isDragging = true;
        hasMoved = false;
        stopAutoPlay();

        startX = e.clientX;
        element.style.transition = "";
        element.setPointerCapture(e.pointerId);
    }

    function onPointerMove(e) {
        if (!isDragging || e.buttons !== 1) return;
        
        var dx = e.clientX - startX;

        if (!hasMoved && Math.abs(dx) > dragThreshold) {
            hasMoved = true;
            element.classList.add('dragging');
        }
    
        if (!hasMoved) return;

        lastTranslate = currentTranslate + dx;

        var maxTranslate = -(element.scrollWidth - element.offsetWidth);
        var maxOverflow = itemWidth + itemGap;
        
        lastTranslate = Math.max(maxTranslate - maxOverflow, Math.min(lastTranslate, maxOverflow));
        element.style.transform = "translateX(" + lastTranslate + "px)";
    }

    function onPointerUp(e) {
        if (!isDragging) return;

        if (!hasMoved) {
            return handleItemClick(e);
        }

        var snappedTranslate = snapToNearest(lastTranslate, (itemWidth + itemGap));
        var direction = snappedTranslate > currentTranslate ? "prev" : "next";

        updateTranslate(snappedTranslate, direction, lastTranslate);

        isDragging = false;
        hasMoved = false;
        element.classList.remove('dragging');
    }

    function autoPlay() {
        if (!isAutoPlay) return;
    
        autoPlayIntervalId = setInterval(function () {
            if (!isDragging && !isAnimating) {
                handleNextAutoPlay();
            }
        }, (speed * 1000));
    }

    function stopAutoPlay() {
        if (autoPlayIntervalId) {
            clearInterval(autoPlayIntervalId);
            autoPlayIntervalId = null;
            isAutoPlay = false;
        }
    }

    prevArrow.addEventListener('click', handlePrevArrowClick);
    nextArrow.addEventListener('click', handleNextArrowClick);
    element.addEventListener('pointerdown', function(e) { onPointerDown(e) });
    element.addEventListener('pointermove', function(e) { onPointerMove(e) });
    element.addEventListener('pointerup', function(e) { onPointerUp(e) });
    window.addEventListener('resize', handleBrowserResize);

    element.addEventListener('click', function(e) {
        e.preventDefault();

        var activeItem = getCurrentActiveItem();
        var linkElm = activeItem ? activeItem.querySelector('.custom-link') : null;
        var url = linkElm.getAttribute('href');
        var video = linkElm.dataset.videoModal;
        var modal = linkElm.dataset.promoLink;

        if (!url && !video && !modal) {
            e.stopPropagation();
        }
    });

    autoPlay();

}

var init = function () {
    var carousels = document.querySelectorAll('.images-carousel');

    carousels.forEach(function(carousel) {
        var track = carousel.querySelector('.images-carousel-track');
        var arrows = carousel.querySelector('.arrows');

        if (track && arrows) {
            setArrowOffset(track);
            enableTransformDrag(track, arrows);
        }

    });
};

module.exports = {
  init: init
};